import axios from 'axios';
import { useEffect } from 'react';
import { useAppConfig } from '../../appConfig';
/** Configures Axios baseUrl property when an MSRC config loads. */
export const useAuthAxiosBaseUrl = () => {
    const { apiRoot } = useAppConfig();
    useEffect(() => {
        axios.defaults.baseURL = apiRoot;
    }, [apiRoot]);
};
